import { combine, withCallback } from 'react-hooks-combine'

import ChooseWinnerComponent from './component'

export const ChooseWinner = combine(
  withCallback(
    'onChangeProxy',
    (_state, { onChange }) =>
      ({ currentTarget }) => {
        const { id } = currentTarget.dataset
        onChange({ target: { value: id } })
      },
    ['onChange']
  )
)(ChooseWinnerComponent)
